// Details.js
import React, { useState, useReducer, useEffect } from "react";
import PropTypes from "prop-types";
import { I18n } from "aws-amplify/utils";
import {
  Box,
  Button,
  Card,
  CardContent,
  Container,
  Grid,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { Link, useParams } from "react-router-dom";
import CropFreeIcon from "@mui/icons-material/CropFree";
import CloseIcon from "@mui/icons-material/Close";
import SplitterLayout from "react-splitter-layout";
import "react-splitter-layout/lib/index.css";
import TemplateBox from "components/TemplateBox";
import CallSplitIcon from "@mui/icons-material/CallSplit";
import Contacts from "../Contacts";
import { tlmGetAlarmRate } from "layouts/dashboard/apiService";
import AlarmDetailsContent from "../AlarmDetailsContent";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import dayjs from "dayjs";
import { useTemplateController } from "context";
dayjs.extend(utc);
dayjs.extend(timezone);
function reducer(state, action) {
  switch (action.type) {
    case "DATA_RECEIVED":
      return { ...state, data: action.value, loading: false };
    case "ERROR":
      return { ...state, error: action.error, loading: false };
    default:
      return state;
  }
}

const initialState = {
  data: null,
  loading: true,
  error: null,
};

function Details({ isOpen, onClose, rowData, language, profile, fetchLists }) {
  const { id } = useParams();
  const theme = useTheme();
  const mobileDevice = !useMediaQuery(theme.breakpoints.up("md"));

  const [showPopup, setShowPopup] = useState(false);
  const handlePopUpButtonClick = (id) => {
    setShowPopup(!showPopup);
  };
  const [controller] = useTemplateController();
  const { darkMode } = controller;
  // Salva il campo id dalla costante data
  const data = rowData && rowData.length > 0 ? rowData[0] : {};
  const alarmId = data.id; // Salva il campo `id` di `rowData`
  const [state, dispatch] = useReducer(reducer, initialState);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await tlmGetAlarmRate(alarmId);
        dispatch({ type: "DATA_RECEIVED", value: response });
      } catch (error) {
        dispatch({ type: "ERROR", error });
      }
    };
    fetchData();
  }, [alarmId]);

  // Destructure fields from the state
  const { data: alarmRateData, loading, error } = state;
  const formatTimestamp = (value) => {
    if (!value) {
      return ""; // Gestisce valori null o undefined
    }
    return dayjs
      .utc(value) // Interpreta il valore come UTC
      .tz(dayjs.tz.guess()) // Converte al fuso orario locale
      .format("YYYY-MM-DD HH:mm:ss"); // Formato desiderato
  };

  return (
    <>
      <SplitterLayout
        vertical={mobileDevice}
        percentage={true}
        primaryMinSize={30}
        secondaryMinSize={30}
        secondaryInitialSize={50}
      >
        <div>
          <TemplateBox height="15px" />
          <Box
            sx={{
              position: "sticky",
              top: 0,
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              zIndex: 10,
              bgcolor: darkMode ? "#1f2020" : "background.paper",
              p: 2,
              borderRadius: 2, // Adds rounded corners
              boxShadow: 1, // Adds shadow similar to a card
            }}
          >
            <Typography variant="h5" sx={{ fontSize: "1.2rem" }}>
              {`${data.original_store} | ${data.original_equipment} | ${formatTimestamp(
                data.datetime_start
              )} | ${data.alarm_type_description} | ${data.alarm_text}`}
            </Typography>

            <Box>
              <IconButton
                color="primary"
                onClick={() => handlePopUpButtonClick(id)}
              >
                <CallSplitIcon />
              </IconButton>
              <IconButton color="secondary" onClick={onClose}>
                <CloseIcon />
              </IconButton>
            </Box>
          </Box>
          <Container maxWidth="lg">
            <AlarmDetailsContent
              data={data} // Original alarm data
              language={language}
              profile={profile}
              alarmRateData={alarmRateData} // New data passed
              fetchLists={fetchLists}
            />
          </Container>
        </div>

        {showPopup && (
          <Contacts
            isOpen={showPopup}
            onClose={() => setShowPopup(false)}
            rowData={rowData}
          />
        )}
      </SplitterLayout>
    </>
  );
}

Details.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  rowData: PropTypes.object.isRequired,
};

export default Details;
